<mat-menu>
  @for (action of actions; track action) {
  <button (click)="action.action()" [disabled]="!action.visible()" [title]="action.label | transloco" mat-menu-item>
    @if (action.icon) {
    <mat-icon class="mr-1">{{ action.icon }}</mat-icon>
    } @if (action.logo) {
    <!-- eslint-disable-next-line -->
    <img [src]="action.logo" class="inline h-16 mr-1" />
    }
    {{ action.label | transloco }}
  </button>
  @if (action.divider) {
  <mat-divider></mat-divider>
  } }
</mat-menu>
